import { Component, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import * as fromStore from '../../store';
import { MessageService } from 'primeng/api';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { DeviceGroupParam } from '../../models/group';
import { updateInfoType } from '../../shareModel';
import { Subject, Subscription, combineLatest } from 'rxjs';
import { takeUntil, first } from 'rxjs/operators';
import * as fromMyfeatures from '../../my-features';
import { UpdateInfoModel } from '../../my-features/updateInfo/update-info.model';
import { isODM } from '../../../environments/environment';
import { Confirm_button } from '../../../environments/environment';
import {TranslateService} from '@ngx-translate/core';
import { User } from '../../models/user';

@Component({
  standalone: false,
  selector: 'app-delete-group',
  templateUrl: './delete-group.component.html',
  styleUrls: ['./delete-group.component.css']
})
export class DeleteGroupComponent implements OnInit, OnDestroy {
  displayConfirmDialog = false;
  deviceGroupParam = {} as DeviceGroupParam;
  private deleteGroupInfo: Subscription;
  private componentDestroyed = new Subject();
  UpdateInfoParam = {} as UpdateInfoModel;
  powerMaster = isODM;
  Confirm_button = Confirm_button;
  mspRegionFilter = null;
  constructor(private translateService: TranslateService, private store: Store<fromStore.State>, private messageService: MessageService,
     private ngxService: NgxUiLoaderService) {

      // combineLatest(this.store.select(fromStore.getCurrentUser), this.store.select(fromStore.getMspRegionFilter))
      // .pipe(takeUntil(this.componentDestroyed)).subscribe(([user, filter]) => {
      //   this.mspRegionFilter = null;
      //   if (user && !user.isLoading && user.isLoaded && user.isLogin && filter !== null && filter.filterLoaded) {
      //     if (filter.isMsp) {
      //       this.mspRegionFilter = filter.selectedId;
      //     }
      //   }
      // });

      this.store.select(fromStore.getMspRegionFilter).pipe(takeUntil(this.componentDestroyed)).subscribe(res => {
        this.mspRegionFilter = null;
        if (res !== null && res.filterLoaded) {
          if (res.isMsp) {
            this.mspRegionFilter = res.selectedId;
          }
        }
      });
    }

  ngOnInit() {
  }

  deleteGroup(gId) {
    this.deviceGroupParam = {
      ...this.deviceGroupParam,
      gId,
    };
    this.displayConfirmDialog = true;
  }

  refresh() {
    this.ngxService.start();
    const param = {regionIds : this.mspRegionFilter};
    const UserParam = {regionIds: this.mspRegionFilter} as User;
    this.store.dispatch(new fromStore.GetDevicesStatusAction(UserParam));
    this.store.dispatch(new fromStore.GetDeviceInfoAction(param));
    this.store.dispatch(new fromStore.GetGroups(param));
    // this.basedOnModeofTrack();
    this.displayConfirmDialog = false;
    this.ngxService.stop();
  }

  saveDeleteGroup() {
    this.store.dispatch(new fromStore.DeleteDeviceGroup({ ...this.deviceGroupParam }));
    this.store.select(fromStore.getUpdateInfoState).pipe(first(res => res.isLoaded && res.type === updateInfoType.DeleteDeviceGroup))
    .subscribe(res => {
      if (res.type === updateInfoType.DeleteDeviceGroup) {
        if (res.isLoading) {
          console.log('...Loading');
        } else {
          if (res.isLoaded) {
            if (res.isSaved) {
              this.messageService.add({ severity: 'success', summary: this.translateService.instant('Update Success') });
              this.refresh();
              // alert('success');
            } else {
              // alert('fail');
              this.messageService.add({ severity: 'error', summary: this.translateService.instant('Update Fail') });
            }
            this.resetUpdateInfoState();
          }
        }
      }
    });
  }

  ngOnDestroy() {
    this.componentDestroyed.next(undefined);
    this.componentDestroyed.complete();
  }

  private resetUpdateInfoState(type: string = updateInfoType.FreeState): void {
    this.UpdateInfoParam = { ...this.UpdateInfoParam, type };
    this.store.dispatch(new fromMyfeatures.UpdateInfoSuccessAction({ ...this.UpdateInfoParam }));
  }
}
